import React, { useState } from 'react';
import { MessageCircle, Dumbbell } from 'lucide-react';
import { ContactFormModal } from './ContactFormModal';

export const Services = () => {
  const [activeModal, setActiveModal] = useState(null);

  const services = [
    {
      icon: <MessageCircle size={40} />,
      title: 'Beratung (30 Min)',
      price: '90€',
      features: [
        'Analyse von Haltung und Schmerzen',
        'Individuelle Empfehlungen',
        'Klarer, strukturierter Plan',
        'Per Videocall'
      ],
      buttonText: 'Beratung buchen',
      serviceType: 'consulting',
      isInquiry: false
    },
    {
      icon: <Dumbbell size={40} />,
      title: 'Personal Training',
      price: '120€ / Stunde',
      features: [
        'Intensive 1:1-Begleitung',
        'Technik, Kraft, Stabilität, Mobilität',
        'Online oder offline',
        'Ideal für Anfänger & Athleten'
      ],
      buttonText: 'Personal Training anfragen',
      serviceType: 'personal_training',
      isInquiry: true,
      image: 'https://customer-assets.emergentagent.com/job_haltung-reset/artifacts/ss22u6ds_IMG_0894.jpeg'
    }
  ];

  return (
    <section style={{
      padding: 'var(--spacing-giant) 0',
      background: 'var(--bg-subtle)'
    }}>
      <div className="container">
        <div style={{ textAlign: 'center', marginBottom: 'var(--spacing-xl)' }}>
          <h2 className="display-medium" style={{ marginBottom: 'var(--spacing-medium)' }}>
            Beratung & Personal Training
          </h2>
          <p className="body-large" style={{ maxWidth: '700px', margin: '0 auto' }}>
            Individuelle Unterstützung für deinen Weg zu mehr Bewegungsfreiheit.
          </p>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
          gap: 'var(--spacing-xl)',
          maxWidth: '900px',
          margin: '0 auto'
        }}>
          {services.map((service, index) => (
            <div key={index} className="network-card" style={{
              cursor: 'default',
              display: 'flex',
              flexDirection: 'column'
            }}>
              {service.image && (
                <div style={{
                  borderRadius: '24px',
                  overflow: 'hidden',
                  marginBottom: 'var(--spacing-medium)',
                  height: '250px'
                }}>
                  <img 
                    src={service.image}
                    alt={service.title}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      display: 'block'
                    }}
                  />
                </div>
              )}
              <div style={{
                color: 'var(--brand-dark)',
                marginBottom: 'var(--spacing-medium)'
              }}>
                {service.icon}
              </div>
              <h3 className="heading-2" style={{ marginBottom: 'var(--spacing-small)' }}>
                {service.title}
              </h3>
              <div style={{
                fontSize: 'clamp(1.5rem, 3vw, 2rem)',
                fontWeight: 700,
                color: 'var(--brand-dark)',
                marginBottom: 'var(--spacing-medium)'
              }}>
                {service.price}
              </div>
              <div style={{ marginBottom: 'var(--spacing-large)', flexGrow: 1 }}>
                {service.features.map((feature, idx) => (
                  <p key={idx} className="body-medium" style={{ marginBottom: 'var(--spacing-small)' }}>
                    • {feature}
                  </p>
                ))}
              </div>
              <button 
                onClick={() => setActiveModal(service.serviceType)}
                className="btn-primary" 
                style={{ width: '100%', justifyContent: 'center' }}
                data-testid={`buy-${service.serviceType}-button`}
              >
                {service.buttonText}
              </button>
            </div>
          ))}
        </div>
      </div>

      {/* Contact Form Modals */}
      <ContactFormModal
        isOpen={activeModal === 'consulting'}
        onClose={() => setActiveModal(null)}
        serviceType="consulting"
        title="Online-Beratung buchen"
        description="Füllen Sie das Formular aus, um fortzufahren. Sie werden dann zur Zahlung weitergeleitet."
        isInquiry={false}
      />
      <ContactFormModal
        isOpen={activeModal === 'personal_training'}
        onClose={() => setActiveModal(null)}
        serviceType="personal_training"
        title="Personal Training Anfrage"
        description="Fülle das Formular aus und ich melde mich bei dir."
        showLocation={true}
        isInquiry={true}
      />
    </section>
  );
};
